<template>
  <MarketingPageShell>
    <template #hero>
      <span class="hero-badge">笔芯科研</span>
      <h1>{{ seo.h1 }}</h1>
      <p class="hero-lead">{{ seo.description }}</p>
      <div class="hero-actions">
        <router-link to="/workbench" class="btn-primary">立即免费试用</router-link>
        <router-link to="/pricing" class="btn-outline">查看套餐价格</router-link>
      </div>
    </template>

    <article class="landing-article">
      <section v-for="(block, idx) in sections" :key="idx" class="landing-section">
        <h2>{{ block.heading }}</h2>
        <p>{{ block.body }}</p>
      </section>
      <AcademicComplianceNotice />
      <p class="landing-cta">
        <router-link to="/workbench">进入在线工作台开始处理</router-link>
        ·
        <router-link to="/faq">常见问题</router-link>
        ·
        <router-link to="/faq#compliance">合规说明</router-link>
      </p>
    </article>
  </MarketingPageShell>
</template>

<script>
import MarketingPageShell from '@/components/portal/MarketingPageShell.vue'
import AcademicComplianceNotice from '@/components/portal/AcademicComplianceNotice.vue'
import { resolvePageSeo, LANDING_PAGE_SECTIONS } from '@/constants/siteSeo'

export default {
  name: 'MarketingFeatureLandingView',
  components: { MarketingPageShell, AcademicComplianceNotice },
  computed: {
    path() {
      return this.$route.path
    },
    seo() {
      return resolvePageSeo(this.path)
    },
    sections() {
      return LANDING_PAGE_SECTIONS[this.path] || []
    }
  }
}
</script>

<style scoped>
.hero-lead {
  max-width: 720px;
  line-height: 1.7;
  color: #4b5563;
}

.hero-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 20px;
}

.btn-outline {
  display: inline-flex;
  align-items: center;
  height: 44px;
  padding: 0 20px;
  border-radius: 10px;
  border: 1px solid #dbeafe;
  color: var(--primary, #1976d2);
  font-weight: 500;
}

.landing-article {
  max-width: 800px;
}

.landing-section {
  margin-bottom: 28px;
}

.landing-section h2 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 10px;
}

.landing-section p {
  line-height: 1.75;
  color: #4b5563;
}

.landing-cta {
  margin-top: 32px;
  font-size: 14px;
  color: #6b7280;
}

.landing-cta a {
  color: var(--primary, #1976d2);
}
</style>
